export default "__VITE_ASSET__DVhAS_Y2__"